import { Layout } from "@/components/layout/Layout";
import {
  LoadI18nMessagesProps,
  loadIntlMessages,
} from "@/utils/loadIntlMessages";
import { getStrapiCollection, getStrapiEntity } from "@/utils/strapi";
import { routes } from "@/routes/routes";
import { queryPartnerPage } from "@/strapiQuery/partnerPage";
import {
  formatFirstPartnerPage,
  StrapiPartnerPage,
} from "@/utils/formatPartnerPage";
import { page404 } from "@/const/page404";
type GetStaticPropsParams = LoadI18nMessagesProps & {
  params: { slug: string };
};

export const getStaticProps = async (ctx: GetStaticPropsParams) => {
  const layout = await getStrapiEntity<Layout>("layout", "");

  const partnersContentPromise = await getStrapiCollection<StrapiPartnerPage>(
    "partner-pages",
    queryPartnerPage(ctx.params.slug)
  );
  if (partnersContentPromise.length === 0) {
    return page404;
  }

  const intlMessages = loadIntlMessages(ctx);
  const partnersPageContent = formatFirstPartnerPage(partnersContentPromise);

  return {
    props: {
      layout,
      intlMessages,
      slug: ctx.params.slug,
      seo: partnersPageContent.seo,
      seoWithoutTemplate: partnersPageContent.seoWithoutTemplate,
      pointOfInterestList: partnersPageContent.pointOfInterestList,
      descriptiveBlockList: partnersPageContent.descriptiveBlockList,
      breadcrumbLabel: partnersPageContent.breadcrumbLabel,
      heroBlock: partnersPageContent.heroBlock,
      defaultCanonicalRoute: routes.partnerPage(ctx.params.slug),
    },
    revalidate: 10,
  };
};

export const getStaticPaths = () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};
export { PartnerPage as default } from "@/components/pages/partnerPage/PartnerPage";
